import { instance } from '@/services/iss-nattag-api.service'
import { Role } from '@/types/role'
import { AxiosResponse } from 'axios'

const URL = 'role'

export const getRoles = (): Promise<AxiosResponse<Role[]>> =>
  instance.get(`${URL}`)
